export enum Errors {
  // Search
  QueryParameterRequired = 'A query parameter is required.',
}
